// extracted by mini-css-extract-plugin
export default {"containerAgradecimiento":"Gracias_containerAgradecimiento__KKEwI","agradecimientoResplandeciente":"Gracias_agradecimientoResplandeciente__HR5z0"};